






import { Component, mixins, Watch } from 'nuxt-property-decorator';
import BaseLayoutMixin from "../../node_modules/sitis-nuxt/lib/cms/BaseLayoutMixin";
import SPage from "~/components/page/SPage.vue";
import { AppMixin } from "~/node_modules/sitis-nuxt/lib/mixins";

@Component({
  components: { SPage },
})
export default class MainLayout extends mixins(BaseLayoutMixin, AppMixin) {
  show = false
}
